import { useContract } from './useContract'
import { ABI_COCOS_FANTASY } from '../utils/abis'
import { useCallback } from 'react'
import { useBlindBoxApproved } from './useNFTApproved'
import { DialogType, useDialog } from '../context/DialogContext'
import useEnvConfig from 'hooks/useEnvConfig'
import { BigNumber } from 'ethers'

export default function useOpenBlindBox() {
  const envConfig = useEnvConfig()
  const contract = useContract(envConfig.ADDRESS_COCOSFANTASYBLINDBOX, ABI_COCOS_FANTASY)
  const { approve, approved } = useBlindBoxApproved(envConfig.ADDRESS_COCOSFANTASYBLINDBOX, false)
  const { open } = useDialog()
  const claim = useCallback(
    async (tokenId: number, callback?: Function) => {
      if (contract) {
        try {
          if (!approved) {
            await approve()
          }
          open(DialogType.Waiting, { title: 'Waiting for sign transaction!' })
          const claim = await contract.claim(tokenId)
          open(DialogType.Waiting, { title: 'Waiting for confirmation.' })
          await claim.wait()
          open(DialogType.Waiting, { title: 'Waiting for confirmation.', desc: 'NFT will show up in 1-3 minutes.' })
          const callListener = (sender: string, _tokenId: BigNumber, reqId: string) => {
            console.log('callListener', sender, +_tokenId, reqId)
            if (tokenId === +_tokenId) {
              open(DialogType.Success, { title: 'Success!' })
              callback && callback()
            }
          }
          contract.on('eveTapNFT', callListener)
        } catch (e:any) {
          open(DialogType.Error, { title: 'Failed', desc: e.message || e.data.message || 'unknown error!' })
        }
      }
    },
    [contract, approved, approve, open],
  )
  return { claim }
}
